exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".home.container-fluid{overflow:hidden}.home .my-auto{margin-top:auto;margin-bottom:auto}.home .content-section{max-width:1050px}.home .content-section h2{font-weight:700}.home .content-section h3{text-align:center;font-size:1.6rem;padding:.4rem 0;font-weight:700}.home .content-section span{text-align:center;display:inline-block}.home .content-section .partner-redirect-box{background-color:#fff;padding:40px}.home .redirect-row{background-color:#f7f7f7;padding:40px 40px 80px 40px}.home .product-tiles{padding:40px 40px 40px 40px}.home .product-tiles p{padding-bottom:20px;text-align:center;font-size:1.1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PartnerReferral/PartnerReferral.scss
// module id = 8095
// module chunks = 13